import { createFileRoute } from '@tanstack/react-router';
import { SnapshotList } from '@features/document-snapshots/SnapshotList';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/t/contracts/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdOn', sortDir: 'desc' }),
  component: ContractsPage,
});

function ContractsPage() {
  const searchParams = Route.useSearch();
  return <SnapshotList searchParams={searchParams} />;
}
